import { link } from "@/components/Action.tsx";

export const profileLink = link({ to: "/profile" });
